{
  "RESET_PASSWORD": {
    "TITLE": "パスワードをリセット",
    "DESCRIPTION": "Chatwootにログインする際に使用するメールアドレスを入力して、パスワードリセットの手順を受け取ってください。",
    "GO_BACK_TO_LOGIN": "ログインページに戻りたい場合は、",
    "EMAIL": {
      "LABEL": "Eメール",
      "PLACEHOLDER": "メールアドレスを入力してください。",
      "ERROR": "有効なメールアドレスを入力してください."
    },
    "API": {
      "SUCCESS_MESSAGE": "パスワードリセット用のリンクがあなたのメールアドレス宛に送信されました.",
      "ERROR_MESSAGE": "Woot Serverに接続できませんでした。もう一度お試しください。"
    },
    "SUBMIT": "送信"
  }
}
